import React, { FunctionComponent } from "react"
import Nouislider from "nouislider-react"
import "nouislider/distribute/nouislider.css"
import { FieldValues } from "react-hook-form"

interface iProps {
  label?: string
  name: string
  value: number
  error?: FieldValues
  onChange?: (val: any) => void
  animate?: boolean
  connect?: boolean
  range: any
  step: any
  style?: any
  format?: any
  start: number
  orientation?: "horizontal" | "vertical"
  tooltips?: boolean
}

const SliderInput: FunctionComponent<iProps> = ({
  name,
  label,
  range,
  step,
  style,
  format,
  orientation = "horizontal",
  animate = true,
  connect = false,
  tooltips,
  onChange,
  start,
}) => {
  return (
    <div className="vraa-slider-wrap">
      <Nouislider
        animate={animate}
        connect={connect}
        range={range}
        step={step}
        style={style}
        start={start}
        format={format}
        orientation={orientation}
        tooltips={tooltips}
        onChange={(d) => {
          console.log(d)

          onChange && onChange(d)
        }}
      />
    </div>
  )
}

export default SliderInput
